<asw-booking-completed-pres
  [displayTitleLabel]="displayLabel"
  [paymentInformation]="paymentInformation"
  [isBaggageRuleExist]="isBaggageRuleExist"
  (returnToMyBooking)="goToMyBooking($event)"
  (eTicketPdfCall)="eTicketPdfCall()"
  (returnToAswTop)="returnToAswTop()"
  [mybookingBaggageRulesData]="mybookingBaggageRulesData"
  [displayBaggageRulesArea]="displayBaggageRulesArea"
  [pnrInfo]="pnrInfo"
>
</asw-booking-completed-pres>
